export enum InvoiceState {

  DRAFT = 'DRAFT',
  ORDER = 'ORDER',
  COST_ESTIMATE = 'COST_ESTIMATE',
  INVOICE = 'INVOICE',
  CANCELLATION = 'CANCELLATION',
}
